import { render, staticRenderFns } from "./TemplateInputWings.vue?vue&type=template&id=f4e909d0&"
import script from "./TemplateInputWings.vue?vue&type=script&lang=ts&"
export * from "./TemplateInputWings.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateInputWings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports